import { render, staticRenderFns } from "./RegionDetailPage.vue?vue&type=template&id=5bea8364"
import script from "./RegionDetailPage.ts?vue&type=script&lang=js&external"
export * from "./RegionDetailPage.ts?vue&type=script&lang=js&external"
import style0 from "./RegionDetailPage.vue?vue&type=style&index=0&id=5bea8364&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports